"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Ctor = {};
exports.default = Ctor;
//# sourceMappingURL=WrappedPropertyCtor.js.map